import { EasyVrpMapContext } from './EasyVrpMapContext';
import { Vehicle } from '../../Vehicles/Vehicle';
import { EasyVrpMapPoint, type IVehicleOnMap } from './EasyVrpMapPoint';
import type { CalcNucleiResponseType } from '../EasyVrpApi';

export class EasyVrpMapNucleiManager {
    mapNuclei: EasyVrpMapPoint[] = [];
    private readonly _onNucleiDragEnd: (x: number, y: number, vehicle_id: number) => void;

    constructor(onNucleiDragEnd: (x: number, y: number, vehicle_id: number) => void) {
        this._onNucleiDragEnd = onNucleiDragEnd;
    }

    public addNucleiToMap(mc: EasyVrpMapContext, selectedVehicleId: number | null = null): void {
        this.clearMap();
        mc.getContext().extra_data.nuclei.forEach(nuclei => {
            if (selectedVehicleId !== null && nuclei.vehicle_id !== selectedVehicleId) {
                return; // Skip if not the selected vehicle
            }
            // console.log('#map-nuclei Adding nuclei to map', nuclei.vehicle_id, nuclei.coordinates);
            let vehicle = mc
                .getContext()
                .vehicles.find((v: Vehicle) => v.getId() === nuclei.vehicle_id);
            const x = nuclei.coordinates.x;
            const y = nuclei.coordinates.y;
            const color = mc.getColor(nuclei.vehicle_id) || '#98c8f8';
            const opacity = 0.8;
            // const position = {
            //     vehicle: vehicle || new Vehicle(),
            // };
            let vehicleName =
                mc.getVehicleName(nuclei.vehicle_id) || 'nuclei-vehicle-id-' + nuclei.vehicle_id;
            this.addNuclei(
                x,
                y,
                color,
                opacity,
                vehicleName,
                this._onNucleiDragEnd,
                nuclei.vehicle_id
            );
        });
    }

    public addNucleiToMapFromQuickCalc(
        resultNuclei: CalcNucleiResponseType[],
        vehicles: Vehicle[] = [],
        zoomToBounds: boolean = false
    ): void {
        this.clearMap();
        resultNuclei.forEach(nuclei => {
            console.log(
                '#map-nuclei Adding nuclei addNucleiToMapFromQuickCalc',
                nuclei.id,
                nuclei.geom.coordinates
            );
            const [x, y] = nuclei.geom.coordinates;
            const color = nuclei.color;
            const opacity = 0.8;
            let vehicleName =
                vehicles.find(v => v.getId() === nuclei.id)?.getName() || 'undefined-vehicle';
            let vehicleId = nuclei.id || null;

            this.addNuclei(x, y, color, opacity, vehicleName, this._onNucleiDragEnd, vehicleId);
        });
        if (zoomToBounds) {
            this.zoomToBounds();
        }
    }

    private addNuclei(
        x: number,
        y: number,
        color: string,
        opacity: number,
        vehicleName: string,
        onDragEnd: (x: number, y: number, vehicle_id: number) => void,
        vehicleId: number | null = null
    ): void {
        let newPoint = new EasyVrpMapPoint();
        newPoint.drawPoint(x, y, color, opacity, vehicleName, false, onDragEnd, vehicleId);
        this.mapNuclei.push(newPoint);
    }

    public clearMap(): void {
        console.log('#map Removing all map points', this.mapNuclei.length);
        this.mapNuclei.forEach(point => point.removePoint());
        this.mapNuclei = [];
    }

    public zoomToBounds(): void {
        if (this.mapNuclei.length === 0) {
            console.warn('#map No points to zoom to bounds');
            return;
        }
        let bounds = { minX: 180, minY: 180, maxX: -180, maxY: -180 };
        this.mapNuclei.forEach(point => {
            bounds.minX = Math.min(bounds.minX, point.getX());
            bounds.minY = Math.min(bounds.minY, point.getY());
            bounds.maxX = Math.max(bounds.maxX, point.getX());
            bounds.maxY = Math.max(bounds.maxY, point.getY());
        });
        if (bounds) {
            Targeo.Base.Map.zoomToBounds(bounds, false, [80, 120, 20, 180]);
        }
    }
}
